import { render, staticRenderFns } from "./vipPage.vue?vue&type=template&id=2f07dcce&scoped=true&"
import script from "./vipPage.vue?vue&type=script&lang=js&"
export * from "./vipPage.vue?vue&type=script&lang=js&"
import style0 from "./vipPage.vue?vue&type=style&index=0&id=2f07dcce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07dcce",
  null
  
)

export default component.exports